import { Unauthorized } from 'unauthorized/Unauthorized';

export function UnauthorizedResolver() {
  return <Unauthorized />;
}
